import { IUpdateProjetoArquivoUseCase } from "../../../presentation/useCases/update/update_projeto_arquivo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class UpdateProjetoArquivoUseCase implements IUpdateProjetoArquivoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async  updateProjetoArquivo(IdProjetoArquivo: number,     
  IdProjeto: number,    
  Descricao: string | null,    
  Nome: string | null,           
  Arquivo: File | null): Promise<void> {
    return await this.repository.updateProjetoArquivo(IdProjetoArquivo, IdProjeto, Descricao, Nome, Arquivo);
  }
}
